import { getConfig } from '@klpkonsern/appconfig';
import { ContractManagementModuleName } from '@/routing/Routes';
import type { ContractManagementTabs } from '@/routing/Routes';
import { IconName } from '@klp/design/Illustrations';
import { SidebarMenuItem } from '@klp/layout/Sidebar/classes/SidebarMenuItem';
import { generateRoute } from '@klp/routing';
import type { User } from '@klp/user';

// Extend AppConfigParameters for this module
declare global {
    interface AppConfigParameters {
        WEBAPP_LEKO_ENABLE: boolean;
    }
}

// Helper functions
export const getLekoEnable = (): boolean =>
    getConfig('WEBAPP_LEKO_ENABLE', false);

export const ContractManagementRoutes = {
    moduleRoute: () => generateRoute([ContractManagementModuleName]),
    tab: (tab?: ContractManagementTabs | ':tab') =>
        generateRoute([ContractManagementModuleName, tab]),
};

// eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
export const ContractManagementAccess = (user?: User): boolean =>
    (getConfig('WEBAPP_CONTRACT_ENABLE', false) &&
        user &&
        (user.isSuperUser || user.isAdmin)) ||
    false;

export const ContractManagementMenuItems = [
    new SidebarMenuItem({
        route: ContractManagementRoutes.moduleRoute(),
        matchRoute: ContractManagementRoutes.moduleRoute(),
        icon: IconName.DOCUMENTS,
        translation: 'contractManagement.title',
        access: ContractManagementAccess,
    }),
];
